;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { SITE_CONFIG_ID, graphRequest } from 'services/contentful';

import { assetFragment, iconFragment } from 'lib/graphql/fragments';

import BlockPersonalizedRecipes from './BlockPersonalizedRecipes';

const query = /* GraphQL */ `
    ${assetFragment}
    ${iconFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockPersonalizedRecipes(preview: $preview, id: $id) {
            __typename
            anchorId
            flushTop
            flushBottom
            icon {
                ... on Icon {
                    ...Icon
                }
            }
            headline {
                json
            }
            curatedRecipesCollection: mostFavoritedRecipesCollection(
                limit: 12
            ) {
                items {
                    __typename
                    sys {
                        id
                    }
                    ... on Recipe {
                        title
                        slug
                        category {
                            title
                        }
                        prepTime
                        cookTime
                        cardImage {
                            ...Asset
                        }
                        cardImageLarge {
                            ...Asset
                        }
                    }
                }
            }
        }
    }
`;

// Fetch all recipes needed for client-side filtering inside the block
const recipesQuery = /* GraphQL */ `
    ${assetFragment}
    query getRecipesForBlock($preview: Boolean) {
        recipes: recipeCollection(
            limit: 300
            order: [order_ASC, sys_firstPublishedAt_DESC]
            preview: $preview
        ) {
            items {
                __typename
                sys {
                    id
                }
                title
                slug
                cookTime
                prepTime
                serves
                category {
                    title
                }
                cardImage {
                    ...Asset
                }
                cardImageLarge {
                    ...Asset
                }
                image {
                    ...Asset
                }
                keywords
                weather
                attributes
            }
        }
    }
`;

const recipesConfigQuery = /* GraphQL */ `
    query getRecipesConfigForBlock($preview: Boolean!, $id: String!) {
        siteConfig(preview: $preview, id: $id) {
            contentTypeAttributes
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockPersonalizedRecipes },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockPersonalizedRecipes;
}

const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

async function fetchTopFavoritedRecipeIds() {
    if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return [];
    const url = `${SUPABASE_URL}/rest/v1/favorite_counts?select=item_id,total_count&item_type=eq.recipe&order=total_count.desc&limit=12`;
    const res = await fetch(url, {
        headers: {
            apikey: SUPABASE_ANON_KEY,
            Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        },
        next: { revalidate: 300 },
    });
    if (!res.ok) return [];
    const data = await res.json();
    return (data || []).map(r => r.item_id).filter(Boolean);
}

// No need to fetch recipes by IDs on the server; client maps IDs via RecipesDataContext

const BlockPersonalizedRecipesServer = async ({ id }) => {
    const block = await fetchBlock(id);

    const mostFavoritedIds = await fetchTopFavoritedRecipeIds();
    const curatedRecipes = block.curatedRecipesCollection?.items || [];

    // Fetch all recipes and config for local filtering in the block client
    const [allRecipesRes, recipesConfigRes] = await Promise.all([
        graphRequest({ query: recipesQuery }),
        graphRequest({
            query: recipesConfigQuery,
            variables: { id: SITE_CONFIG_ID },
        }),
    ]);

    const allRecipes =
        allRecipesRes?.body?.data?.recipes?.items?.filter(
            item => item?.__typename === 'Recipe'
        ) || [];
    const recipesConfig =
        recipesConfigRes?.body?.data?.siteConfig?.contentTypeAttributes
            ?.recipe || {};

    return (
        <BlockPersonalizedRecipes
            {...block}
            curatedRecipes={curatedRecipes}
            mostFavoritedIds={mostFavoritedIds}
            allRecipes={allRecipes}
            recipesConfig={recipesConfig}
        />
    );
};

export default BlockPersonalizedRecipesServer;
